import { useState } from "react";
import { useEffect } from "react";

// @styles
import "./styles.scss";

export default function AlertInfo({ message, img }) {
  return (
    <div className="alert-info__container">
      <div className="container-xl">
        <div className="alert-info__container-item">
          <div className="alert-info__container-item__img">
            <img src={img.url} alt={img.alt} />
          </div>
          <div className="alert-info__container-item__text">
            {message.map((e) => (
              <>
                <div className="alert-info__container-item__text-title">
                  {e.title}
                </div>
                <div className="alert-info__container-item__text-description">
                  {e.description}
                </div>
              </>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
